/*!

=========================================================
* Now UI Dashboard Pro Angular - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-angular
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { registerLicense } from '@syncfusion/ej2-base';
if (environment.production) {
  enableProdMode();
}

// Enhanced Syncfusion license registration with error handling
try {
  console.info('🔑 Registering Syncfusion license key...');
  registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1feHRWQ2hYWUVxX0E=');
  console.info('✅ Syncfusion license registered successfully');
} catch (licenseError) {
  console.error('🚨 Failed to register Syncfusion license:', licenseError);
  console.warn('⚠️ Some Syncfusion components may show trial banners');
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
